/* eslint-disable */

import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ROLL_CALL_API_BASE_URL } from "../../feature-module/Pereco/RollCall/RollCallConfig/RollCallConfig";
import { Dropdown, Space, Drawer } from "antd";
import Sidebar from "./Sidebar";
import logo from "../../assets/logo.png";
import Swal from "sweetalert2";

import {
  UsergroupAddOutlined,
  CalendarOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";

const Header = () => {
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [flagImage, setFlagImage] = useState("assets/img/flags/in.png");
  const { t, i18n } = useTranslation();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [menuData, setMenuData] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    oldpwd: "",
    newpwd: "",
  });
  const [showOldPwd, setShowOldPwd] = useState(false);
  const [showNewPwd, setShowNewPwd] = useState(false);
  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const userId = userData?.UserId;

  useEffect(() => {
    if (!userId || !tokenData) return;
    const fetchMenu = async () => {
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}ess/access/getessmenu?UserId=${userId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
              "Content-Type": "application/json",
            },
          },
        );

        console.log("Status:", response.status);

        const result = await response.json();
        if (result?.status && Array.isArray(result?.ResultData)) {
          setMenuData(result.ResultData);
        }
        if (result?.status && Array.isArray(result.ResultData)) {
          const flatPermissions = {};

          const flatten = (items) => {
            items.forEach((item) => {
              if (item.link && item.link !== "#") {
                flatPermissions[item.link] = {
                  canRead: item.canRead,
                  canWrite: item.canWrite,
                  canDelete: item.canDelete,
                  canExport: item.canExport,
                };
              }

              if (
                Array.isArray(item.submenuItems) &&
                item.submenuItems.length > 0
              ) {
                flatten(item.submenuItems);
              }
            });
          };

          flatten(result.ResultData);

          sessionStorage.setItem(
            "rollcall-permissions",
            JSON.stringify(flatPermissions),
          );

          console.log("Saved permissions map:", flatPermissions);
        }
      } catch (err) {
        console.error("Failed to fetch menu:", err);
      }
    };

    fetchMenu();
  }, [userId, tokenData]);

  const buildMenuItems = (items) => {
    return items.map((item) => {
      const hasSubmenu = item.submenuItems && item.submenuItems.length > 0;

      if (hasSubmenu) {
        return {
          key: item.AppMenuId,
          label: item.label,
          children: buildMenuItems(item.submenuItems),
        };
      }

      return {
        key: item.AppMenuId,
        label: (
          <Link
            to={item.link}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {item.label}
          </Link>
        ),
      };
    });
  };
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? "assets/img/flags/us-flag.svg"
        : lng === "fr"
          ? "assets/img/flags/fr.png"
          : lng === "es"
            ? "assets/img/flags/es.png"
            : "assets/img/flags/de.png",
    );
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);

  useEffect(() => {
    const fetchNotificationData = async () => {
      if (tokenData && superIdData && userData?.RegId) {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/notification/getNotification?superid=${superIdData}&regid=${userData?.RegId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            },
          );

          if (!response.ok) {
            throw new Error("Failed to fetch employees");
          }

          const data = await response.json();
          if (data.status) {
            setData(data.ResultData || []);
          } else {
            console.error("Error fetching employees:", data.ErrorMsg);
          }
        } catch (error) {
          console.error("Error fetching employees:", error);
        } finally {
        }
      }
    };

    fetchNotificationData();
  }, [superIdData, tokenData, userData?.RegId]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement,
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("superId");
    sessionStorage.clear();
    localStorage.clear();

    navigate("/rollcall/signin");
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  // const sidebarOverlay = () => {
  //   document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
  //   document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
  //   document?.querySelector("html")?.classList?.toggle("menu-opened");
  // };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };
  const { expandMenus } = useSelector(
    (state) => state.themeSetting.expandMenus,
  );
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes
  const RESPONSE_TIMEOUT = 2 * 60 * 1000; // 2 minutes

  const inactivityTimerRef = useRef(null);
  const responseTimerRef = useRef(null);

  const activityEvents = [
    "mousemove",
    "keydown",
    "scroll",
    "click",
    "touchstart",
  ];

  // 🔐 Logout function
  const clearAuth = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("superId");
    sessionStorage.removeItem("userMenu");
    sessionStorage.removeItem("userData");
    sessionStorage.removeItem("rollcall-permissions");
    sessionStorage.clear();

    navigate("/signin", { replace: true });
  };

  const startResponseTimer = () => {
    responseTimerRef.current = setTimeout(() => {
      Swal.close();
      clearAuth(); // auto logout after 2 mins
    }, RESPONSE_TIMEOUT);
  };

  const showSessionPopup = () => {
    startResponseTimer();

    Swal.fire({
      title: "Session Expiring",
      text: "Your session is about to expire. Do you want to continue?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Continue",
      cancelButtonText: "No, Logout",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      clearTimeout(responseTimerRef.current);

      if (result.isConfirmed) {
        resetTimer(); // reset 15 min timer
      } else {
        clearAuth(); // logout immediately
      }
    });
  };

  const resetTimer = () => {
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }

    inactivityTimerRef.current = setTimeout(() => {
      showSessionPopup(); // trigger swal after 15 mins
    }, INACTIVITY_TIMEOUT);
  };

  useEffect(() => {
    if (!userData?.RegId) return;

    resetTimer();

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer, { passive: true });
    });

    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      if (responseTimerRef.current) {
        clearTimeout(responseTimerRef.current);
      }

      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, [userData?.RegId]);

  const showDrawer = () => setOpen(true);
  const onClose = () => {
    setOpen(false);
    setFormData({
      oldpwd: "",
      newpwd: "",
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.oldpwd || !formData.newpwd) {
      Swal.fire("Error", "Please fill all fields", "error");
      return;
    }

    try {
      setLoading(true);
      const superId = sessionStorage.getItem("superId");

      const payload = {
        username: userData?.Badge,
        oldpwd: formData.oldpwd,
        newpwd: formData.newpwd,
        SuperId: superId,
      };

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/user/changepwd`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Something went wrong");
      }

      await Swal.fire({
        title: "Password Changed",
        text: "Your password has been changed. Please login again.",
        icon: "success",
        confirmButtonText: "OK",
      });

      sessionStorage.clear();
      localStorage.clear();

      navigate("/signin");
    } catch (err) {
      Swal.fire("Error", err.message || "Failed to change password", "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="header ">
        <div className="main-header d-flex align-items-center px-3">
          {/* <!-- Logo --> */}
          <div className="header-left active d-none d-lg-flex">
            <Link
              to={`/${userData?.DefaultPath}`}
              className="logo logo-normal mt-4"
            >
              <img src={logo} alt="Img" />
            </Link>
            <Link to={`/${userData?.DefaultPath}`} className="logo logo-white">
              <img src={logo} alt="Img" />
            </Link>
            <Link to={`/${userData?.DefaultPath}`} className="logo-small">
              <img src={logo} alt="Img" />
            </Link>
            <Link
              id="toggle_btn"
              to="#"
              style={{
                display:
                  pathname.includes("tasks") || pathname.includes("pos")
                    ? "none"
                    : pathname.includes("compose")
                      ? "none"
                      : "",
              }}
              onClick={handlesidebar}
            >
              <FeatherIcon icon="chevrons-left" className="feather-16" />
            </Link>
          </div>
          {/* /Logo */}
          <Link
            id="mobile_btn"
            className="mobile_btn"
            to="#"
            onClick={() => setIsSidebarOpen(true)}
          >
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </Link>
          <div
            className="d-flex d-lg-none justify-content-center align-items-center w-100"
            style={{ height: "50px" }}
          >
            <Link to="/" className="logo logo-small">
              <img
                src={logo}
                alt="Mobile Logo"
                className="img-fluid p-1"
                style={{ height: "40px", width: "auto" }}
              />
            </Link>
          </div>
          {/* Header Menu */}
          <ul className="nav user-menu ms-auto">
            {/* Search */}
            <li className="nav-item nav-searchinputs">
              <div className="top-nav-search"></div>
            </li>

            {menuData.map((module) => {
              const hasSubmenu =
                module.submenuItems && module.submenuItems.length > 0;

              return (
                <li
                  key={module.AppMenuId}
                  className="nav-item border-bottom border-primary me-2"
                  style={{ display: module.canRead ? "block" : "none" }}
                >
                  {hasSubmenu ? (
                    // Dropdown for modules with submenu (Leaves, Teams, Visitor)
                    <Dropdown
                      menu={{ items: buildMenuItems(module.submenuItems) }}
                      trigger={["hover"]}
                    >
                      <a onClick={(e) => e.preventDefault()}>
                        <Space>
                          <h6 className="text-gray">
                            {module.label === "Attendance" && (
                              <CheckSquareOutlined />
                            )}
                            {module.label === "Leaves" && <CalendarOutlined />}
                            {module.label === "Teams" && (
                              <UsergroupAddOutlined />
                            )}
                            {module.label === "Visitor" && <CalendarOutlined />}
                            {module.label}
                          </h6>
                        </Space>
                      </a>
                    </Dropdown>
                  ) : (
                    // Direct Link for modules without submenu (Attendance)
                    <Link to={module.link}>
                      <Space>
                        <h6 className="text-gray">
                          {module.label === "Attendance" && (
                            <CheckSquareOutlined />
                          )}
                          {module.label}
                        </h6>
                      </Space>
                    </Link>
                  )}
                </li>
              );
            })}

            {/* /Flag */}
            <li className="nav-item nav-item-box">
              <Link
                to="#"
                id="btnFullscreen"
                onClick={() => toggleFullscreen()}
                className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
              >
                {/* <i data-feather="maximize" /> */}
                <i className="ti ti-maximize"></i>
              </Link>
            </li>

            <li className="nav-item dropdown nav-item-box">
              <Link
                to="#"
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                <i
                  className="fa-solid fa-question fa-bounce"
                  style={{ color: "#75736c" }}
                ></i>
              </Link>
              <div className="dropdown-menu notifications">
                <div className="topnav-dropdown-header text-center">
                  <span className="notification-title text-center">
                    Helpful Videos
                  </span>
                </div>
                <div className="noti-content h-auto">
                  <ul className="notification-list">
                    <li className="notification-message">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <i
                            className="fa-brands fa-youtube fs-4"
                            style={{ color: "#f61313" }}
                          ></i>
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">
                              Rollcall Attendance Software
                            </span>
                            <a
                              href="https://www.youtube.com/watch?v=-a0jjcc1Y-k"
                              target="_blank"
                              rel="noreferrer"
                              className="text-info"
                              style={{
                                marginTop: "-1rem",
                                marginLeft: "-0.8rem",
                              }}
                            >
                              Watch the Demo
                            </a>
                          </p>
                        </div>
                      </div>
                    </li>
                    <li className="notification-message">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <i
                            className="fa-brands fa-youtube fs-4"
                            style={{ color: "#f61313" }}
                          ></i>
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">iBizAccounts</span>
                            <a
                              href="https://www.youtube.com/watch?v=e6Npd_cy4JQ"
                              target="_blank"
                              rel="noreferrer"
                              className="text-info"
                              style={{
                                marginTop: "-1rem",
                                marginLeft: "-0.8rem",
                              }}
                            >
                              Watch the Demo
                            </a>
                          </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li className="nav-item dropdown nav-item-box">
              <Link
                to="#"
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                <i className="ti ti-bell"></i>
                {data?.length > 0 && (
                  <span className="badge rounded-pill">{data.length}</span>
                )}
              </Link>
              <div className="dropdown-menu notifications">
                <div className="topnav-dropdown-header">
                  <h5 className="notification-title">Notifications</h5>
                  <Link to="#" className="clear-noti">
                    Mark all as read
                  </Link>
                </div>
                <div className="noti-content">
                  <ul className="notification-list">
                    {data?.length > 0 ? (
                      data.map((item, index) => (
                        <li
                          className="notification-message"
                          key={item.ID || index}
                        >
                          <Link>
                            <div className="media d-flex">
                              <span className="avatar flex-shrink-0">
                                <ImageWithBasePath
                                  alt="Img"
                                  src="assets/img/profiles/avatar-13.jpg"
                                />
                              </span>
                              <div className="flex-grow-1">
                                <p className="noti-details">
                                  <span className="noti-title">
                                    {item.Name}
                                  </span>{" "}
                                  – {item.Description}
                                </p>
                                <p className="noti-time">
                                  {new Date(item.CreatedOn).toLocaleString()}
                                </p>
                              </div>
                            </div>
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li className="notification-message text-center">
                        No notifications found
                      </li>
                    )}
                  </ul>
                </div>
                <div className="topnav-dropdown-footer d-flex align-items-center gap-3">
                  <Link to="#" className="btn btn-secondary btn-md w-100">
                    Cancel
                  </Link>
                  <Link
                    // to={route.rollcallnotification}
                    className="btn btn-primary btn-md w-100"
                  >
                    View all
                  </Link>
                </div>
              </div>
            </li>

            {/* /Notifications */}
            {/* <li className="nav-item nav-item-box">
              <Link to="/rollcall/general-settings">
                <i className="ti ti-settings"></i>
              </Link>
            </li> */}
            <li className="nav-item dropdown has-arrow main-drop profile-nav">
              <Link
                to="#"
                className="nav-link userset"
                data-bs-toggle="dropdown"
              >
                <span className="user-info p-0">
                  <span className="user-letter">
                    <ImageWithBasePath
                      src="assets/img/profiles/avator1.jpg"
                      alt="Img"
                      className="img-fluid"
                    />
                  </span>
                </span>
              </Link>
              <div className="dropdown-menu menu-drop-user">
                <div className="profileset d-flex align-items-center">
                  <span className="user-img me-2">
                    <ImageWithBasePath
                      src="assets/img/profiles/avator1.jpg"
                      alt="Img"
                    />
                  </span>
                  <div>
                    <h6 className="fw-medium"> {userData?.UserName}</h6>
                    {/* <p>Admin</p> */}
                  </div>
                </div>
                {/* <Link className="dropdown-item" to={route.profile}>
                  <i className="ti ti-user-circle me-2" />
                  MyProfile
                </Link> */}
                {/* <Link className="dropdown-item" to="/rollcall/VisitingwithQR">
                  <i className="ti ti-file-text me-2" />
                  Mobile QR Code
                </Link> */}
                {/* <Link className="dropdown-item" to={route.generalsettings}>
                  <i className="ti ti-settings-2 me-2" />
                  Settings
                </Link> */}
                <hr className="my-2" />
                <Link className="dropdown-item" onClick={showDrawer}>
                  <i className="ti ti-settings-2 me-2" />
                  Change Password
                </Link>
                <a className="dropdown-item logout pb-0" onClick={handleLogout}>
                  <i className="ti ti-logout me-2" />
                  Logout
                </a>
              </div>
            </li>
          </ul>
          {/* /Header Menu */}
          {/* Mobile Menu */}
          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              {/* <Link className="dropdown-item" to="profile">
                My Profile
              </Link>
              <Link className="dropdown-item" to="generalsettings">
                Settings
              </Link> */}
              <Link className="dropdown-item" onClick={handleLogout}>
                Logout
              </Link>
            </div>
          </div>
          {/* /Mobile Menu */}
        </div>
        <>
          <Sidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
          />

          {isSidebarOpen && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 bg-light bg-opacity-50"
              style={{
                backdropFilter: "blur(5px)",
                zIndex: "1040",
                transition: "opacity 0.3s ease-in-out",
                cursor: "pointer",
              }}
              onClick={() => setIsSidebarOpen(false)}
            />
          )}
        </>
        <Drawer
          title="Change Password"
          placement="right"
          onClose={onClose}
          open={open}
          width={400}
        >
          <form onSubmit={handleSubmit}>
            {/* Username */}
            <div className="mb-3">
              <label className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                value={userData?.UserName}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Old Password</label>
              <div className="pass-group">
                <input
                  type={showOldPwd ? "text" : "password"}
                  className="pass-input form-control"
                  name="oldpwd"
                  value={formData.oldpwd}
                  onChange={handleChange}
                />
                <span
                  className={`ti toggle-password ${showOldPwd ? "ti-eye-off" : "ti-eye"}`}
                  onClick={() => setShowOldPwd(!showOldPwd)}
                ></span>
              </div>
            </div>

            {/* New Password */}
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <div className="pass-group">
                <input
                  type={showNewPwd ? "text" : "password"}
                  className="pass-input form-control"
                  name="newpwd"
                  value={formData.newpwd}
                  onChange={handleChange}
                />
                <span
                  className={`ti toggle-password ${showNewPwd ? "ti-eye-off" : "ti-eye"}`}
                  onClick={() => setShowNewPwd(!showNewPwd)}
                ></span>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Updating..." : "Change Password"}
            </button>
          </form>
        </Drawer>
      </div>
    </>
  );
};

export default Header;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// // import Navbar from "./Navbar";
// import Sidebar from "./Sidebar";

// const Header = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//  const handleLogout = () => {
//   console.log("Logout clicked");
//   sessionStorage.clear();
//   window.location.href = "/";
// };
//   return (
//     <div>
//       {/* <!-- Header --> */}
//       <div className="header ">
//         <div className="main-header d-flex align-items-center px-3">
//           {/* <!-- Logo --> */}
//           <div className="header-left active d-none d-lg-flex">
//             <Link to="/" className="logo logo-normal">
//               <img src="assets/img/logo.png" alt="Img" />
//             </Link>
//             <Link to="/" className="logo logo-white">
//               <img src="assets/img/logo.png" alt="Img" />
//             </Link>
//             <Link to="/" className="logo-small">
//               <img src="assets/img/logo.png" alt="Img" />
//             </Link>
//           </div>
//           {/* <!-- /Logo --> */}

//           <a
//             id="mobile_btn"
//             className="mobile_btn"
//             href="#sidebar"
//             onClick={() => setIsSidebarOpen(!isSidebarOpen)}
//           >
//             <span className="bar-icon">
//               <span></span>
//               <span></span>
//               <span></span>
//             </span>
//           </a>
//           <div className="d-flex d-lg-none justify-content-center align-items-center w-100" style={{ height: "50px" }}>
//             <Link to="/" className="logo logo-small">
//               <img
//                 src="assets/img/logo.png"
//                 alt="Mobile Logo"
//                 className="img-fluid p-1"
//                 style={{ height: "40px", width: "auto" }}
//               />
//             </Link>
//           </div>
//           {/* <!-- Header Menu --> */}
//           <ul className="nav user-menu ms-auto">
//             {/* <!-- Notifications --> */}
//             <li className="nav-item dropdown nav-item-box">
//               <a
//                 href="#"
//                 className="dropdown-toggle nav-link"
//                 data-bs-toggle="dropdown"
//               >
//                 <i className="ti ti-bell fs-4"></i>
//               </a>
//               <div className="dropdown-menu notifications">
//                 <div className="topnav-dropdown-header">
//                   <h5 className="notification-title">Notifications</h5>
//                   <Link className="clear-noti">
//                     Mark all as read
//                   </Link>
//                 </div>
//                 <div className="noti-content">
//                   <ul className="notification-list">
//                     <li className="notification-message">
//                       <Link to="">
//                         <div className="media d-flex">
//                           <span className="avatar flex-shrink-0">
//                             <img
//                               alt="Img"
//                               src="assets/img/profiles/Linkvatar-13.jpg"
//                             />
//                           </span>
//                           <div className="flex-grow-1">
//                             <p className="noti-details">
//                               <span className="noti-title">James Kirwin</span>{" "}
//                               confirmed his order. Order No: #78901.Estimated
//                               delivery: 2 days
//                             </p>
//                             <p className="noti-time">4 mins ago</p>
//                           </div>
//                         </div>
//                       </Link>
//                     </li>
//                     <li className="notification-message">
//                       <Link to="">
//                         <div className="media d-flex">
//                           <span className="avatar flex-shrink-0">
//                             <img
//                               alt="Img"
//                               src="assets/img/profiles/Linkvatar-03.jpg"
//                             />
//                           </span>
//                           <div className="flex-grow-1">
//                             <p className="noti-details">
//                               <span className="noti-title">Leo Kelly</span>{" "}
//                               cancelled his order scheduled for 17 Jan 2025
//                             </p>
//                             <p className="noti-time">10 mins ago</p>
//                           </div>
//                         </div>
//                       </Link>
//                     </li>
//                     <li className="notification-message">
//                       <Link to="" className="recent-msg">
//                         <div className="media d-flex">
//                           <span className="avatar flex-shrink-0">
//                             <img
//                               alt="Img"
//                               src="assets/img/profiles/Linkvatar-17.jpg"
//                             />
//                           </span>
//                           <div className="flex-grow-1">
//                             <p className="noti-details">
//                               Payment of $50 received for Order #67890 from{" "}
//                               <span className="noti-title">Antonio Engle</span>
//                             </p>
//                             <p className="noti-time">05 mins ago</p>
//                           </div>
//                         </div>
//                       </Link>
//                     </li>
//                     <li className="notification-message">
//                       <Link to="" className="recent-msg">
//                         <div className="media d-flex">
//                           <span className="avatar flex-shrink-0">
//                             <img
//                               alt="Img"
//                               src="assets/img/profiles/Linkvatar-02.jpg"
//                             />
//                           </span>
//                           <div className="flex-grow-1">
//                             <p className="noti-details">
//                               <span className="noti-title">Andrea</span>{" "}
//                               confirmed his order. Order No: #73401.Estimated
//                               delivery: 3 days
//                             </p>
//                             <p className="noti-time">4 mins ago</p>
//                           </div>
//                         </div>
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//                 <div className="topnav-dropdown-footer d-flex align-items-center gap-3">
//                   <Link to="#" className="btn btn-secondary btn-md w-100">
//                     Cancel
//                   </Link>
//                   <a
//                     href="activities.html"
//                     className="btn btn-primary btn-md w-100"
//                   >
//                     View all
//                   </a>
//                 </div>
//               </div>
//             </li>
//             {/* <!-- /Notifications --> */}
//             <li className="nav-item">
//               <Link
//                 onClick={handleLogout}
//                 to="/" className="nav-link text-danger rounded d-flex align-items-center">
//                 <i className="ti ti-logout fs-4"></i>
//               </Link>
//             </li>
//           </ul>
//           {/* <!-- /Header Menu --> */}

//           {/* <!-- Mobile Menu --> */}
//           <div className="dropdown mobile-user-menu">
//             <a
//               href="#"
//               className="nav-link dropdown-toggle"
//               data-bs-toggle="dropdown"
//               aria-expanded="false"
//             >
//               <i className="fa fa-bars"></i>
//             </a>
//             <div className="dropdown-menu dropdown-menu-right">
//               <a className="dropdown-item" href="signin.html">
//                 <i className="ti ti-logout me-1"></i>Logout
//               </a>
//             </div>
//           </div>
//           {/* <!-- /Mobile Menu --> */}
//         </div>
//       </div>
//       {/* <!-- /Header --> */}
//       {/* <Navbar /> */}
//       <>
//         <Sidebar
//           isOpen={isSidebarOpen}
//           onClose={() => setIsSidebarOpen(false)}
//         />

//         {isSidebarOpen && (
//           <div
//             className="position-fixed top-0 start-0 w-100 h-100 bg-light bg-opacity-50"
//             style={{
//               backdropFilter: "blur(5px)",
//               zIndex: "1040",
//               transition: "opacity 0.3s ease-in-out",
//               cursor: "pointer",
//             }}
//             onClick={() => setIsSidebarOpen(false)}
//           />
//         )}

//       </>
//     </div>
//   );
// };

// export default Header;
